import { NavItem } from "@data-access/shared";

export const DEFAULT_SUBMISSION_TYPE_ROUTES =  new Set<NavItem>([
  {
    label: 'Questionnaire',
    path: 'questionnaire',
  },
  {
    label: 'Document Tasks',
    path: 'document-tasks',
  }, {
    label: 'Document Types',
    path: 'document-types',
  }
]);
